import React from 'react';
import { Chip } from 'factor';
import { Draggable, DraggableProvided } from 'react-beautiful-dnd';

import { Option } from 'models/Option';

interface Props {
  items: Option[];
  onRemove: (item: Option) => void;
  dnd?: boolean;
  className?: string;
  chipClassName?: string;
  icon?: React.ReactElement;
}

export const Chips = (props: Props): any => {
  const { items, className, chipClassName, dnd, onRemove, icon } = props;

  return items.map((item, index) => {
    const itemClassName = className || chipClassName || '';

    return dnd ? (
      <Draggable key={item.value} draggableId={item.label} index={index}>
        {(providedDraggable: DraggableProvided) => (
          <div
            data-qa="55"
            ref={providedDraggable.innerRef}
            /* eslint-disable react/jsx-props-no-spreading */
            {...providedDraggable.draggableProps}
            {...providedDraggable.dragHandleProps}
            /* eslint-enable react/jsx-props-no-spreading */
          >
            <Chip item={item} onRemove={onRemove} className={className || ''} />
            {providedDraggable.placeholder}
          </div>
        )}
      </Draggable>
    ) : (
      <Chip
        key={item.value}
        item={item}
        icon={icon}
        onRemove={onRemove}
        className={itemClassName}
      />
    );
  });
};
